import popup from '__jsLibs/popup';

export default {
	openPopup(state) {
		state.popup = true;
	},

	closePopup(state) {
		state.popup = false;
	},

	clearTimer(state) {
		clearTimeout(state.timer);
	},

	autoSave(state, payload) {
		state.timer = payload;
	},

	...popup,

	setPopupTitle(state, payload) {
		state.popupTitle = payload;
	},
	setLoad(state, payload) {
		state.load = payload;
	},
	setId(state, payload) {
		state.id = payload;
	},
	setDeal(state, payload) {
		state.deal = payload;
	},
	setTenants(state, payload) {
		state.tenants = payload;
	},
	setMaintenance(state, payload) {
		state.maintenance = payload;
	},
	setAmortizationAnnually(state, payload) {
		state.amortizationAnnually = payload;
	},
	setAmortizationMonthly(state, payload) {
		state.amortizationMonthly = payload;
	},
	setMaintenanceNotes(state, data) {
		state.maintenance[data.i].notes = data.newVal;
	},
	setTempMaintenanceNotes(state, data) {
		state.tempMaintenance[data.i].notes = data.newVal;
	},
	setMaintenanceName(state, data) {
		state.maintenance[data.i].name = data.newVal;
	},
	setTempMaintenanceName(state, data) {
		state.tempMaintenance[data.i].name = data.newVal;
	},

	setMaintenancePhoto(state, data) {
		state.maintenance[data.i].attachments.push(data);
	},
	addMaintance(state) {
		state.tempMaintenance.push({
			attachments:     undefined,
			default_section: undefined,
			help_text:       undefined,
			id:              undefined,
			name:            '',
			notes:           '',

		});
	},
	removeMaintance(state, index) {
		state.maintenance.splice(index, 1);
	},
	removeTempMaintance(state, index) {
		state.tempMaintenance.splice(index, 1);
	},
	/// /////////////////////////////////////////////////////////
	editTenant(state, data) {
		state.tenants[data.id][data.field] = data.value;
		if (state.tenantsErrors[[data.id]]) {
			state.tenantsErrors[data.id][data.field] = '';
		}
	},
	setTenantsErrors(state, data) {
		state.tenantsErrors = data;
	},
	addTenant(state, tenant) {
		state.tenants.push(tenant);
	},
	removeTenant(state, index) {
		state.tenants.splice(index, 1);
	}

};
